import ErrorModel from '../../../../vendor_core/core/src/model/ErrorModel';
import SpinModel from '../../../../vendor_core/core/src/model/SpinModel';
import { ICondition } from '../../../../vendor_core/core/src/states/State';
import { DefaultLayers } from '../../../../vendor_core/core/src/utils/Layers';
import ViewManager from '../../../../vendor_core/core/src/utils/ViewManager';
import VendorModel from '../../../../vendor_core/server/model/VendorModel';
import BBReelGroup from '../../view/BBReelGroup';

export default class BBHasFreeGamesExpiredCondition implements ICondition {
    check(): boolean {
        let freeGamesExpired: boolean = false;

        if (VendorModel.inFreeGames) {
            if (ErrorModel.errorCode === 560) {
                freeGamesExpired = true;
                VendorModel.hasFreeGamesExpired = true;
                ErrorModel.cleanUp();
            }
        } else {
            freeGamesExpired = false;
        }

        return freeGamesExpired
    }
}
